export default {
    experiment: 'Experiment',
    experiment_action: 'Aufgabe',
    experiment_metric: 'Zwischenergebnis',
};
